/* eslint-disable */
// this is an auto generated file. This will be overwritten

export const getTaxReturn = /* GraphQL */ `
  query GetTaxReturn($email: String!, $taxYear: String!) {
    getTaxReturn(email: $email, taxYear: $taxYear) {
      id
      email
      taxYear
      workFlowStatus
      workFlowChangedStatus
      currentYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      previousYearDocument {
        items {
          id
          fileName
          note
          type
          s3key
          s3bucket
          s3region
          verified
          taxReturnID
          createdAt
          updatedAt
          owner
        }
        nextToken
      }
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listTaxReturns = /* GraphQL */ `
  query ListTaxReturns(
    $email: String
    $taxYear: ModelStringKeyConditionInput
    $filter: ModelTaxReturnFilterInput
    $limit: Int
    $nextToken: String
    $sortDirection: ModelSortDirection
  ) {
    listTaxReturns(
      email: $email
      taxYear: $taxYear
      filter: $filter
      limit: $limit
      nextToken: $nextToken
      sortDirection: $sortDirection
    ) {
      items {
        id
        email
        taxYear
        workFlowStatus
        workFlowChangedStatus
        currentYearDocument {
          nextToken
        }
        previousYearDocument {
          nextToken
        }
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getTaxDocument = /* GraphQL */ `
  query GetTaxDocument($id: ID!) {
    getTaxDocument(id: $id) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listTaxDocuments = /* GraphQL */ `
  query ListTaxDocuments(
    $filter: ModelTaxDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listTaxDocuments(filter: $filter, limit: $limit, nextToken: $nextToken) {
      items {
        id
        fileName
        note
        type
        s3key
        s3bucket
        s3region
        verified
        taxReturnID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
export const getPreviousTaxDocument = /* GraphQL */ `
  query GetPreviousTaxDocument($id: ID!) {
    getPreviousTaxDocument(id: $id) {
      id
      fileName
      note
      type
      s3key
      s3bucket
      s3region
      verified
      taxReturnID
      createdAt
      updatedAt
      owner
    }
  }
`;
export const listPreviousTaxDocuments = /* GraphQL */ `
  query ListPreviousTaxDocuments(
    $filter: ModelPreviousTaxDocumentFilterInput
    $limit: Int
    $nextToken: String
  ) {
    listPreviousTaxDocuments(
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        fileName
        note
        type
        s3key
        s3bucket
        s3region
        verified
        taxReturnID
        createdAt
        updatedAt
        owner
      }
      nextToken
    }
  }
`;
